import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useState } from 'react'
import { accountsService, ProviderAccess } from '@/services/accounts.service'
import { toast } from 'sonner'

interface ProviderPurchaseModalProps {
  provider: ProviderAccess | null
  open: boolean
  onClose: () => void
  onSuccess: () => void
}

export function ProviderPurchaseModal({ provider, open, onClose, onSuccess }: ProviderPurchaseModalProps) {
  const [loading, setLoading] = useState(false)

  const initiatePayment = async () => {
    if (!provider) return
    setLoading(true)
    try {
      const response = await accountsService.purchaseProviderAccess(provider.provider_code)
      if (response.checkout_url) {
        window.location.href = response.checkout_url
      } else {
        toast.error('Errore nell\'inizializzazione del pagamento')
      }
    } catch (err: any) {
      toast.error(err?.message || 'Errore nell\'inizializzazione del pagamento')
    } finally {
      setLoading(false)
    }
  }

  if (!provider) return null

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            Sblocca {provider.provider_name}
          </DialogTitle>
          <DialogDescription>
            Acquista l'accesso a {provider.provider_name} con un pagamento una tantum.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="bg-slate-800/50 rounded-lg p-4">
            <div className="flex justify-between items-center">
              <span className="text-sm text-slate-400">Prezzo</span>
              <span className="text-2xl font-bold text-white">€{provider.one_time_price}</span>
            </div>
            <p className="text-xs text-slate-500 mt-2">Pagamento una tantum - Accesso permanente</p>
          </div>
          
          <ul className="space-y-2 text-sm text-slate-300">
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Accesso completo al provider {provider.provider_name}
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Hedging automatico con configurazioni ottimizzate
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Calcolatore con parametri specifici
            </li>
          </ul>

          <div className="flex gap-3">
            <Button variant="outline" onClick={onClose} className="flex-1">
              Annulla
            </Button>
            <Button onClick={initiatePayment} disabled={loading} className="flex-1">
              {loading ? 'Caricamento...' : `Paga €${provider.one_time_price}`}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
